import React from 'react';
import GetSimulationReportCustomizedSetting from './GetSimulationReportCustomizedSetting';
import TabSec from './TabSec';
import SimulationReportCustomizedSetting from './SimulationReportCustomizedSetting';

export default function CustomizedLayoutSettings({
  data,
  isLoading,
  selectedTempInfo,
  handleSelectedTemplate,
  tab = 'SmbSimulationResultPage',
  setTab,
}) {
  const tabBody = () => {
    if (tab === 'SmbSimulationResultPage') {
      return (
        <SimulationReportCustomizedSetting
          data={data}
          isLoading={isLoading}
          selectedTempInfo={selectedTempInfo}
          handleSelectedTemplate={handleSelectedTemplate}
        />
      );
    }
    return <GetSimulationReportCustomizedSetting />;
  };
  return (
    <div>
      <TabSec tab={tab} setTab={setTab} />
      {tabBody()}
    </div>
  );
}
